import React, { useState, useEffect } from "react";
import { Box, ButtonBase } from "@mui/material";
import { PlayCircleOutline } from "@mui/icons-material";
import { embeddableVideoUrl } from "../utils/helpers";

function MediaSlide({ slide }) {
  if (slide.type === "video") {
    const embedUrl = embeddableVideoUrl(slide.src);
    if (embedUrl) {
      return (
        <Box
          component="iframe"
          src={embedUrl}
          title="Product video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          sx={{ width: "100%", height: "100%", border: 0 }}
        />
      );
    }
    return (
      <Box component="video" src={slide.src} controls playsInline sx={{ width: "100%", height: "100%", objectFit: "contain", bgcolor: "#000" }} />
    );
  }
  return <Box component="img" src={slide.src} alt="" sx={{ width: "100%", height: "100%", objectFit: "cover" }} />;
}

// Supports any mix of image and video slides (a product's cover image, its
// extra product_images, and its optional video_url — see utils/helpers.js
// productMedia) behind one main viewer with a thumbnail strip, matching the
// multi-image/video product detail the waiter app's simpler single-image
// card never needed.
export default function MediaGallery({ slides, height = 320 }) {
  const [active, setActive] = useState(0);

  useEffect(() => setActive(0), [slides]);

  if (!slides || slides.length === 0) {
    return <Box sx={{ height, bgcolor: "grey.100" }} />;
  }

  const current = slides[Math.min(active, slides.length - 1)];

  return (
    <Box>
      <Box sx={{ height, bgcolor: "#000", position: "relative" }}>
        <MediaSlide key={current.key} slide={current} />
      </Box>
      {slides.length > 1 && (
        <Box sx={{ display: "flex", gap: 1, overflowX: "auto", p: 1 }}>
          {slides.map((slide, i) => (
            <ButtonBase
              key={slide.key}
              onClick={() => setActive(i)}
              sx={{
                width: 56,
                height: 56,
                borderRadius: 1.5,
                overflow: "hidden",
                flexShrink: 0,
                border: "2px solid",
                borderColor: i === active ? "primary.main" : "transparent",
                position: "relative",
                bgcolor: "grey.100",
              }}
            >
              {slide.type === "video" ? (
                <>
                  <Box component="video" src={slide.src} sx={{ width: "100%", height: "100%", objectFit: "cover" }} />
                  <PlayCircleOutline sx={{ position: "absolute", inset: 0, m: "auto", color: "#fff", fontSize: 20 }} />
                </>
              ) : (
                <Box component="img" src={slide.src} alt="" sx={{ width: "100%", height: "100%", objectFit: "cover" }} />
              )}
            </ButtonBase>
          ))}
        </Box>
      )}
    </Box>
  );
}
